@for (ranking of rankings; track ranking) {
  <slotcom-ranking-item
    [ranking]="ranking"
    [isFriends]="isFriends"
    [showMedals]="showMedals"
    [hideReward]="hideReward"></slotcom-ranking-item>
}
